import { axiosInstanceNoToken } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_FEEDBACK_REQUEST
interface FeedbackRequest {
  name: string;
  email: string;
  phone: string;
  feedback: string;
}

// INTERFACE_SUCCESS_RESPONSE
interface FeedbackSuccessResponse {
  message: string;
  data?: any;
}

// VALIDATION_ERROR
interface ErrorDetail {
  code: string;
  detail: string;
  attr: string;
}

// INTERFACE_ERROR_RESPONSE
interface FeedbackErrorResponse {
  type: 'validation_error';
  errors: ErrorDetail[];
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
  error?: string;
}

// INTERFACE_RESULT
interface FeedbackResult {
  data: FeedbackSuccessResponse | FeedbackErrorResponse | GenericErrorResponse;
  status: number;
}

// POST FEEDBACK API
export const PostFeedback = async (
  feedbackData: FeedbackRequest,
  language: 'az' | 'en' = 'az'
): Promise<FeedbackResult> => {
  try {
    const response = await axiosInstanceNoToken.post<FeedbackSuccessResponse>(
      '/core/feedback',
      feedbackData,
      {
        headers: {
          'Accept-Language': language,
          'Content-Type': 'application/json',
        }
      }
    );

    return {
      data: response.data,
      status: response.status
    };

  } catch (error) {
    if (isAxiosError(error)) {
      // HTTP ERROR
      if (error.response) {
        return {
          data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
          status: error.response.status
        };
      }

      // Network error
      if (error.request) {
        return {
          data: { error: 'Şəbəkə xətası - cavab alınmadı' },
          status: 0
        };
      }
    }

    // Another error
    return {
      data: {
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      },
      status: -1
    };
  }
};